export const common = {
  tryAgain: 'try again',
  expand: 'See more',
  shrink: 'Less',
  noData: 'Sorry, there is \nno data available.',
};
